define('wabreakpoint', ['jquery'], function ($) {

  var wabreakpoint = {
    js_getBreakpoint: function js_getBreakpoint() {
      var _this = this;

      var breakpoint = {};

      breakpoint.refreshValue = function () {
        _this.value = window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/\"/g, '');

        document.getElementsByTagName('body')[0].dataset.js_getBreakpoint = _this.value;
        window.wabreakpoint = _this.value;
      };

      $(window).resize(function () {
        breakpoint.refreshValue();
      }).resize();
    }
  };
  return wabreakpoint;
});

